import { Component, Fragment } from 'react';
import CompareFundWidget from './compareFundWidget';
import { handleTrack } from '../../utils/trackActions';

interface Fund {
  fundName: string;
  imageUrl: string;
  productId: number;
  isinCode: string;
}

interface State {
  totalFunds: number;
  fundList: Fund[];
  isDuplicate: boolean;
  isMaxReached: boolean;
}

const withCompareWidget = (ComposedComponent: any) => {
  class CompareWidgetHOC extends Component<any, State> {
    constructor(props: any) {
      super(props);
      this.state = {
        totalFunds: 0,
        fundList: [],
        isDuplicate: false,
        isMaxReached: false,
      };
    }

    private trackingLabel: string = 'top_funds_button';

    public componentDidMount() {
      // reading the selection list from session
      const fundList =
        JSON.parse(sessionStorage.getItem('fundCompareList')) || [];
      this.setState({
        totalFunds: fundList.length,
        fundList,
      });
    }

    private hideMessage() {
      setTimeout(() => {
        this.setState({
          isMaxReached: false,
          isDuplicate: false,
        });
      }, 5000);
    }

    private deleteFund = (id: number) => {
      const { fundList } = this.state;
      const newList = fundList.filter(fund => fund.productId !== id);
      this.setState({
        fundList: newList,
        totalFunds: newList.length,
      });
      sessionStorage.setItem('fundCompareList', JSON.stringify(newList));
      handleTrack({
        label: `${this.trackingLabel}_popup_widget_delete_fund_${id}`,
      });
    };

    private deleteAll = (e: any) => {
      e.preventDefault();
      this.setState({
        fundList: [],
        totalFunds: 0,
      });
      sessionStorage.setItem('fundCompareList', JSON.stringify([]));
      handleTrack({
        label: `${this.trackingLabel}_popup_widget_delete_all`,
        obj: e.target,
      });
    };

    private addFundToCompare = (fundItem: any) => {
      const { fundList, totalFunds } = this.state;
      if (totalFunds === 4) {
        this.setState({
          isMaxReached: true,
        });
        return this.hideMessage();
      }
      const hasDuplicate = fundList.find(
        fund => fundItem.productId === fund.productId
      );
      if (hasDuplicate) {
        this.setState({
          isDuplicate: true,
        });
        return this.hideMessage();
      }
      const { fundName, imageUrl, productId, fundMetaData } = fundItem;
      handleTrack({
        label: `${this.trackingLabel}_${fundName}_Add_to_Compare`,
      });
      fundList.push({
        fundName,
        imageUrl,
        productId,
        isinCode: fundMetaData.isinCode,
      });
      // updating the selection list to session
      sessionStorage.setItem('fundCompareList', JSON.stringify(fundList));

      this.setState(prevState => {
        return {
          ...prevState,
          totalFunds: prevState.totalFunds + 1,
          fundList,
        };
      });
    };

    public render() {
      return (
        <Fragment>
          <ComposedComponent
            {...this.props}
            addFundToCompare={this.addFundToCompare}
          />
          <CompareFundWidget
            deleteAll={this.deleteAll}
            deleteFund={this.deleteFund}
            {...this.state}
          />
        </Fragment>
      );
    }
  }

  return CompareWidgetHOC;
};

export default withCompareWidget;



// WEBPACK FOOTER //
// ./components/common/compareWidgetHOC.tsx